import { TextInput, Textarea, Stack, Switch } from "@mantine/core";
import { useForm } from "@mantine/form";
import { ReportDeliveryMethod } from "../../../services/admin/reportdeliverymethods.service";
import { required, scrollToFirstError } from "../../../utils/formValidation";

export interface ReportDeliveryMethodFormValues {
  name: string;
  description: string;
  isActive: boolean;
}

interface ReportDeliveryMethodFormProps {
  initialValues?: ReportDeliveryMethod;
  onSubmit: (values: ReportDeliveryMethodFormValues) => void;
}

export default function ReportDeliveryMethodForm({
  initialValues,
  onSubmit,
}: ReportDeliveryMethodFormProps) {
  const form = useForm<ReportDeliveryMethodFormValues>({
    initialValues: {
      name: initialValues?.name || "",
      description: initialValues?.description || "",
      isActive: initialValues?.isActive ?? true,
    },
    validate: {
      name: required("Method name is required"),
    },
  });

  const handleSubmit = form.onSubmit(
    (values) => onSubmit(values),
    () => scrollToFirstError(form)
  );

  return (
    <form noValidate onSubmit={handleSubmit}>
      <Stack gap="md">
        <TextInput
          label="Method Name"
          placeholder="e.g., Fax, Email, Portal"
          withAsterisk
          name="name"
          {...form.getInputProps("name")}
        />

        <Textarea
          label="Description"
          placeholder="Enter delivery method description"
          minRows={3}
          name="description"
          {...form.getInputProps("description")}
        />

        <Switch
          label="Active"
          {...form.getInputProps("isActive", { type: "checkbox" })}
        />
      </Stack>
    </form>
  );
}
